import script from "./HeaderMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderMenu.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderMenu.vue?vue&type=style&index=0&id=3c525b9e&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c525b9e"]])

export default __exports__